import { buildTab } from "@coveo/headless";
import { headlessEngine, headlessEngineTab } from "../engine/engine";

/** General tab to get total count on each pill */
export const generalTab = buildTab(headlessEngineTab, {
  initialState: { isActive: true },
  options: {
    expression:
      '@aem_contenttypevalue==("canon:latam/cla/content/content-type/product", "canon:latam/cla/content/content-type/general-support", "canon:latam/cla/content/content-type/manuals","canon:latam/cla/content/content-type/how-to-videos") OR @source==("Inet Dev - Software and Drivers", "Inet - Software and Drivers") OR @source=="Inet Database - PROD version" AND @commonsupportcontenttype==(Manuals, Brochures, Utilities)',
    id: "generalTab",
  },
});

/**Filters of pills */
export const supportPill = buildTab(headlessEngine, {
  initialState: { isActive: false },
  options: {
    expression:
        /*'@aem_contenttypevalue==("canon:latam/cla/content/content-type/product", "canon:latam/cla/content/content-type/general-support") AND @aem_commoncontenttype==(Manuals, Brochures, Utilities)',*/
        '@aem_contenttypevalue==("canon:latam/cla/content/content-type/product", "canon:latam/cla/content/content-type/general-support", "canon:latam/cla/content/content-type/manuals","canon:latam/cla/content/content-type/how-to-videos") OR @source==("Inet Dev - Software and Drivers", "Inet - Software and Drivers") OR @source=="Inet Database - PROD version" AND @commonsupportcontenttype==(Manuals, Brochures, Utilities)',
    id: "supportPill",
  },
});
export const learningPill = buildTab(headlessEngine, {
  initialState: { isActive: false },
  options: {
    expression:
      '@aem_commoncontenttype==Learning AND @aem_contenttypevalue==("canon:latam/cla/content/content-type/training-and-articles", "canon:latam/cla/content/content-type/inspiration", "canon:latam/cla/content/content-type/case-studies", "canon:latam/cla/content/content-type/events")',
    id: "learningPill",
  },
});

export const resourcesPill = buildTab(headlessEngine, {
  initialState: { isActive: true },
  options: {
    expression:
      '@aem_commoncontenttype==Resources AND @aem_contenttypevalue==("canon:latam/cla/content/content-type/training-and-articles", "canon:latam/cla/content/content-type/whitepaper", "canon:latam/cla/content/content-type/brochure", "canon:latam/cla/content/content-type/simulators", "canon:latam/cla/content/content-type/explore")',
    id: "resourcesPill",
  },
});

